// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Logger } from './logger.service';
import { NoteBackend } from './note.backend';
import { INote } from './note.interface';

@Injectable({
	providedIn: 'root',
})
export class NoteService {
	private noteBackend = inject(NoteBackend);
	private logger = inject(Logger);


	private note!: INote;

	getNotes(params, serviceMethod: string) {
		try {
			return this.noteBackend[serviceMethod](params);
		} catch (error) {
			this.logger.error(error);
			throw error;
		}
	}
	sendNotes(body) {
		try {
			return this.noteBackend.sendNotes(body);
		} catch (error) {
			this.logger.error(error);
			throw error;
		}
	}

	upNotes(body, id) {
		try {
			return this.noteBackend.upNotes(body, id);
		} catch (error) {
			this.logger.error(error);
			throw error;
		}
	}
}
